// Copyright ©️ 2026 eVolve MEP, LLC

import { ToggleRadioGroup } from 'components/Mantine/TypeSafeSelect/ToggleRadioGroup';

import { useBendCreatorValidationContext } from '../Context/useBendCreatorValidationContext';
import { BendConduitSelection } from './BendConduitSelection';

// in feet
const MATERIAL_STOCK_LENGTH_OPTIONS = [10, 20] as const;

export const BendMaterialInputs = () => {
  const { fieldGetInputProps } = useBendCreatorValidationContext();

  return (
    <>
      <BendConduitSelection />
      <ToggleRadioGroup
        {...fieldGetInputProps.materialStockLength()}
        label="Material Stock Length"
        data={MATERIAL_STOCK_LENGTH_OPTIONS.map((length) => ({ id: `${length}`, value: length, label: `${length}'` }))}
        required
      />
    </>
  );
};
